export const completeName = (firstName: string, middleName: string, lastName: string) => {

  return (firstName ? (firstName + ' ') : '') +
    (middleName ? (middleName + ' ') : '') +
    (lastName ? lastName : '');
};

export const uppercaseInitials = (firstName: string, middleName: string, lastName: string) => {

  return (firstName ? firstName.charAt(0).toUpperCase() : '') +
    (middleName ? middleName.charAt(0).toUpperCase() :
      lastName ? lastName.charAt(0).toUpperCase() : '');
};